exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ComponentPanel {\n  -webkit-box-shadow: 1.5px 2.598px 18px 0px rgba(2, 21, 44, 0.059);\n          box-shadow: 1.5px 2.598px 18px 0px rgba(2, 21, 44, 0.059); }\n  .ComponentPanel .box-panel--footer {\n    padding-bottom: 0;\n    padding-right: 0;\n    padding-left: 0;\n    border-top: 1px solid #eeeeee; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/components/Panel.scss
// module id = 521
// module chunks = 0